import { useDispatch } from "react-redux";
import { add, list } from "cart-localstorage";
import { toast } from "react-toastify";
import { Translation } from 'react-i18next';
import { useEffect } from "react";
import { changeHeader } from "../_redux/slices/navSlice";
import { changeCount } from "../_redux/slices/cartSlice";

export async function addToCart({ id, miniDownPayment = 0, name = "", price = 0, brand, image, tax = 0, discount = 0, colorId = "",colorName="", type = "", modelTypes = "test", engine_Groups = "", productID = "", group, brandID }) {
    const success = <Translation ns={"messages"}>
        {
            (t, { i18n }) => <p className={"text-20"}>{t('add_to_cart')}</p>
        }
    </Translation>

    const error = <Translation ns={"messages"}>
        {
            (t, { i18n }) => <p className={"text-20"}>{t('unexpected_errer')}</p>
        }
    </Translation>
    console.log("addToCart:", id);
    console.log("type:", type);
    console.log("colorId:", colorId);



    if (type == "car" && (!colorId || colorId == "")) {
        toast.warning("يجب تحديد اللون", {
            position: "bottom-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });

        return;

    }

    if ((!price)) {
        toast.warning("يجب تحديد السعر", {
            position: "bottom-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });

        return;

    }




    if ((id)) {
        console.log("okkk:");
        const obj = {
            id: id,
            name: name,
            price: price,
            brand: brand,
            group:group,
            image: image,
            Tax: tax,
            Discount: discount,
            Type: type,
            colorID: colorId,
            colorName:colorName,
            BrandID: brandID,
            groupID: group,
            modelTypes: modelTypes,
            Engine_Groups: engine_Groups,
            ProductID: productID
            , MiniDownPayment: miniDownPayment

        }

        console.log("addToCart:", obj);

        const responsAdd = await add(obj);

        console.log("responsAdd:", responsAdd);

        toast.success(success, {
            position: "bottom-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    } else {
        toast.error(<div className={"text-24"}>{error}</div>, {
            position: "bottom-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    }
}